/* eslint-disable no-undef, no-unused-vars */
import $ from 'jquery';

function bindTooltip() {
  require.ensure(['tether-tooltip'], (require) => {
    const Tooltip = require('tether-tooltip');

    const $tooltip = $('.js-tooltip');

    $tooltip.each((index, element) => {
      const $item = $(element);

      function getErrorText() {
        const labelError = $item.parents('.field-container').find('.form__label--error').text();

        return labelError;
      }

      const content = $item.data('tooltip') || $item.attr('title') || getErrorText();

      // to stop the page to error if no attribut is found
      if (!content) {
        return;
      }

      $item.removeAttr('title');

      // eslint-disable-next-line no-new
      const instance = new Tooltip({
        classes: 'netc-tooltip-theme',
        constrainToWindow: true,
        content,
        position: 'bottom left',
        target: $item[0],
        openOn: 'focus',
        tetherOptions: {
          constraints: [
            {
              to: 'scrollParent',
              attachment: 'together',
              pin: true,
            },
          ],
        },
      });

      if ($item.is(':focus')) {
        instance.open();
      }
    });
  });
}

$(document).ready(() => {
  bindTooltip();
});
